import React from "react";
import styled from 'styled-components';
import UserEditHeader from '../components/UI/Header/UserEditHeader';
export default function FavoriteList(){
  return (
    <Wrapper>
      <UserEditHeader title={"관심목록"}/>
    </Wrapper>
  )
}
const Wrapper = styled.div``